import {
  createContext,
  PropsWithChildren,
  RefObject,
  useContext,
  useMemo,
  useRef,
  useState,
} from "react"
import ReCAPTCHA from "react-google-recaptcha"

interface NewslettersV2ContextShape {
  email: string
  setEmail: (email: string) => void
  isSubscribed: boolean
  setIsSubscribed: (value: boolean) => void
  recaptchaRef: RefObject<ReCAPTCHA>
}

/**
 * Context for managing anonymous user state in newsletters-v2 page.
 * Handles email input, subscription status, and reCAPTCHA execution.
 */
const NewslettersV2Context = createContext<NewslettersV2ContextShape>({
  email: "",
  setEmail: () => {},
  isSubscribed: false,
  setIsSubscribed: () => {},
  recaptchaRef: { current: null },
})

export const NewslettersV2Provider = ({ children }: PropsWithChildren) => {
  const [email, setEmail] = useState("")
  const [isSubscribed, setIsSubscribed] = useState(false)
  const recaptchaRef = useRef<ReCAPTCHA>(null)

  const contextValue = useMemo(
    () => ({
      email,
      setEmail,
      isSubscribed,
      setIsSubscribed,
      recaptchaRef,
    }),
    [email, isSubscribed],
  )

  return (
    <NewslettersV2Context.Provider value={contextValue}>{children}</NewslettersV2Context.Provider>
  )
}

export const useNewslettersV2Context = () => useContext(NewslettersV2Context)
